import React, {useState} from 'react';
import {Avatar, Badge, Button} from 'antd';
import {useAppDispatch, useAppSelector} from '../hooks';
import {RootState} from '../store';
import {setTheme} from '../features/theme/themeSlice';
import DarkLight from './DarkLight';
import {User} from "@gravity-ui/uikit";
import {BellOutlined, LoginOutlined} from '@ant-design/icons';
import {Persons} from '@gravity-ui/icons';
import UsersModal from '../modals/UsersModal';
import RegisterModal from '../modals/RegisterModal';
import LoginModal from "../modals/LoginModal";
import UserInfoModal from "../modals/UserInfoModal";
import {ThemeMode} from "../features/theme/THEME_MODES";

interface AppHeaderProps {
}

const AppHeader: React.FC<AppHeaderProps> = () => {
    const theme = useAppSelector((state: RootState) => state.theme.value);
    const dispatch = useAppDispatch();

    const handleThemeChange = (newTheme: ThemeMode) => {
        dispatch(setTheme(newTheme));
    };

    const count = useAppSelector((state) => state.counter.value);

    const [modalOpen, setModalOpen] = useState(false);

    const [isRegisterOpen, setIsRegisterOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);

    const userState = useAppSelector((state: RootState) => state.user);
    const user = userState.user;

    const [isUserModalOpen, setIsUserModalOpen] = useState(false);

    return (
        <>
            <header className="App-header">

                {/* DarkLight compact à gauche */}
                <div className="left top">
                    <DarkLight value={theme} onChange={handleThemeChange}/>
                </div>

                <div className="centered top">
                    <span style={{fontWeight: 500, fontSize: '1.1em'}}>
                    {userState.firm?.name || ''}
                </span>
                </div>

                {/* Users + Bell + Username alignés à droite */}
                <div className="right top">
                    <div className={"RightTop Persons"}
                         onClick={() => setModalOpen(true)}
                         style={{cursor: 'pointer', borderRadius: '4px'}}
                         onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.08)')}
                         onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                    >
                        <Persons/>
                    </div>
                    <div className={"RightTop Bell"}>
                        {user?.username && (
                            <Badge count={count} size="small" overflowCount={20}>
                                <Avatar size="default" icon={<BellOutlined/>}/>
                            </Badge>
                        )}
                    </div>
                    <div className="RightTop UserAvatar">
                        {user?.username ? (
                            <div className={"UserAvatar"}
                                 onClick={() => setIsUserModalOpen(true)}
                                 onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.08)')}
                                 onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                            >
                                <User
                                    avatar={{
                                        text: `${user?.firstName} ${user?.lastName}`,
                                        theme: 'brand'
                                    }}
                                    name={`${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim()}
                                    description={user?.email || ''}
                                    size="m"
                                />
                            </div>
                        ) : (
                            <Button onClick={() => setIsLoginOpen(true)} icon={<LoginOutlined/>}>
                                Se connecter
                            </Button>
                        )}
                    </div>
                </div>

            </header>

            {/* Modals utilisateurs */}
            <UsersModal isOpen={modalOpen} onClose={() => setModalOpen(false)}/>
            <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)}/>
            <RegisterModal open={isRegisterOpen} onClose={() => setIsRegisterOpen(false)}/>
            <UserInfoModal open={isUserModalOpen} onClose={() => setIsUserModalOpen(false)}/>
        </>
    );
};

export default AppHeader;
